import Arithmeglyphs from './Arithmeglyphs';

export default Arithmeglyphs;